import React, { useState } from "react";
import { Gift, X, Copy } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const KEY = "hb_share_reward";

export default function ShareReward({ productId, onClose }) {
  const saved = (() => { try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; } })();
  const [email, setEmail] = useState(saved?.email || "");
  const [result, setResult] = useState(saved && new Date(saved.expires_at) > new Date() ? saved : null);
  const [busy, setBusy] = useState(false);

  const claim = async (ev) => {
    ev.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/share-rewards/claim", { email: email.trim().toLowerCase(), product_id: productId || "" });
      const r = { ...data, email: email.trim().toLowerCase() };
      localStorage.setItem(KEY, JSON.stringify(r));
      setResult(r); toast.success(data.message);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const copy = async () => { try { await navigator.clipboard.writeText(result.code); toast.success("Code copied"); } catch (err) { console.warn("Clipboard blocked", err); toast.error("Couldn't copy — select the code to copy it"); } };
  const exp = result ? new Date(result.expires_at).toLocaleDateString("en-AU", { day: "numeric", month: "long" }) : "";

  return (
    <div className="mt-3 rounded-2xl bg-[#FFF9EE] border-2 border-dashed border-[#FFD93D] p-4 relative" data-testid="share-reward">
      <button type="button" onClick={onClose} aria-label="Close" className="absolute top-2 right-2 text-[#19324A]/40 hover:text-[#19324A]" data-testid="share-reward-close"><X className="w-4 h-4" /></button>
      <p className="font-display font-extrabold text-[#19324A] inline-flex items-center gap-2"><Gift className="w-4 h-4 text-[#FF6B9D]" /> Thanks for sharing — have 5% off!</p>
      {result ? (
        <div className="mt-2" data-testid="share-reward-done">
          <p className="text-xs text-[#19324A]/60">Your single-use code, valid until {exp} (also emailed to {result.email}):</p>
          <button type="button" onClick={copy} className="mt-1.5 inline-flex items-center gap-2 rounded-full bg-[#19324A] text-white font-bold tracking-widest px-4 py-2 text-sm" data-testid="share-reward-code"><Copy className="w-3.5 h-3.5" /> {result.code}</button>
        </div>
      ) : (
        <form onSubmit={claim} className="mt-2 flex flex-col sm:flex-row gap-2">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="flex-1 rounded-xl border-2 border-[#19324A]/10 px-3 py-2 text-sm outline-none focus:border-[#FFD93D] bg-white" data-testid="share-reward-email" />
          <button type="submit" disabled={busy} className="btn-pink !py-2 justify-center" data-testid="share-reward-submit">{busy ? "Sending…" : "Send my code"}</button>
        </form>
      )}
      <p className="text-[10px] text-[#19324A]/45 mt-2">One code per person every 30 days. Valid on your next order.</p>
    </div>
  );
}
